import { ONEILL_MAIN_AGENCY_ID, USER_TYPES } from 'constants/enum';
import { getCompany } from './getCompanyVariables';

const company = getCompany();

export function areCommissionsTabVisible(user) {
  return (
    user?.Entire_Commissions_Tab === 'Force Show' ||
    (user?.Position_at_Agency === USER_TYPES.ADMIN &&
      user?.agencyData?.Parent_Account?.id === ONEILL_MAIN_AGENCY_ID &&
      user?.Entire_Commissions_Tab !== 'Hide') ||
    (!user?.Hide_Commission_Data &&
      user?.Entire_Commissions_Tab !== 'Hide' &&
      !user?.agencyData?.Hide_Commission_Rates_from_Agents) ||
    (user?.Position_at_Agency === USER_TYPES.ADMIN &&
      user?.Entire_Commissions_Tab !== 'Hide' &&
      !user?.Hide_Commission_Data)
  );
}

export function isCommissionsOverviewTabVisible(
  user,
  skipCommissionsTabCheck = false
) {
  return (
    (skipCommissionsTabCheck || areCommissionsTabVisible(user)) &&
    user?.NPN &&
    !user?.Hide_Customers_Commissions_Tab
  );
}

export function areOnboardingInvitesDisabled(agency) {
  if (!agency) return true;
  return (
    company === 'sunshine' ||
    (!agency.Upline_Agency_Allows_Sending_Onboarding_Forms &&
      !agency.Override_Upline_Onboarding_Form_Setting)
  );
}

/**
 * whether the agent's agency opted out of showing announcements on the home page.
 * sunshine only: oneill always shows them, whatever the agency record says
 * @param agency - state.user.zohoData.agencyData
 */
export function areAnnouncementsHidden(agency) {
  if (company !== 'sunshine') return false;
  return Boolean(agency?.Hide_Announcements);
}

export function isLeadPartnersTabVisible(user) {
  return !user?.Hide_Lead_Partners_Tab;
}

// the only sunshine agency whose AmeriHealth-only agents can't request appointments
const AMERIHEALTH_ONLY_AGENCY_ID = '6291220000047935206';

/**
 * whether carrier appointments are unreachable for this user
 * @param user - zoho agent record from state.user.zohoData
 */
export function areAppointmentsDisabled(user) {
  return (
    company === 'sunshine' &&
    user?.Rank === 'AmeriHealth Only' &&
    user?.Account_Name?.id === AMERIHEALTH_ONLY_AGENCY_ID
  );
}

// mirrors the backend allow-list in oneill-marketing-api
// (src/Contexts/ONM/ConverselyAnalysisFile/domain/converselyAnalysisFileAccess.ts) —
// keep both in sync. the agency that owns the files, plus the parent agency whose
// admins oversee it but own no files themselves.
const CALL_REVIEWS_FILES_AGENCY_ID = '6291220000047530071';
const CALL_REVIEWS_ADMIN_VIEWER_AGENCY_IDS = new Set([
  CALL_REVIEWS_FILES_AGENCY_ID,
  '6291220000001933021'
]);

/**
 * whether the Call Reviews section should be reachable for this user.
 * the backend is still the authority — this only decides nav and route registration.
 * @param user - zoho agent record from state.user.zohoData
 * @param viewAsAgent - impersonated agent id from state.user.viewAsAgent, if any
 */
export function isCallReviewsTabVisible(user, viewAsAgent) {
  if (company !== 'sunshine' || viewAsAgent) return false;

  const agencyId = user?.Account_Name?.id;
  if (agencyId === CALL_REVIEWS_FILES_AGENCY_ID) return true;

  const isAdmin = user?.Position_at_Agency === USER_TYPES.ADMIN;
  return isAdmin && CALL_REVIEWS_ADMIN_VIEWER_AGENCY_IDS.has(agencyId);
}
